import { render, staticRenderFns } from "./DataAssetPosition.vue?vue&type=template&id=8f2da342&scoped=true"
import script from "./DataAssetPosition.vue?vue&type=script&lang=js"
export * from "./DataAssetPosition.vue?vue&type=script&lang=js"
import style0 from "./DataAssetPosition.vue?vue&type=style&index=0&id=8f2da342&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f2da342",
  null
  
)

export default component.exports